import React, {Component} from 'react'
import styles from './FJClose.module.less';
import InlineSVG from "react-inlinesvg";
import closeSvg from '../../../icon/close.svg';

class FJClose extends Component {
    render() {

        return (
          <div className={styles.close_box}>
            <InlineSVG src={closeSvg} element='div' />
          </div>
        );
    }
}

export default FJClose;
